import type { VisitRow } from "./types";
import { formatDateTime } from "./format";

export function EmptyRow({ label, colSpan = 1 }: { label: string; colSpan?: number }) {
  return (
    <tr>
      <td className="empty-row" colSpan={colSpan}>
        {label}
      </td>
    </tr>
  );
}

export function RecentVisitorList({ rows }: { rows: VisitRow[] }) {
  if (rows.length === 0) return <li className="empty-card">No recent visitors</li>;

  return (
    <>
      {rows.map((visit) => (
        <li key={`recent-${visit.visit_id}`} className="list-item">
          <div>
            <strong>{visit.visitor_name}</strong>
            <p>{visit.company || "No company"}</p>
          </div>
          <span>{visit.status || "-"}</span>
        </li>
      ))}
    </>
  );
}

export function PendingApprovalList({ rows }: { rows: VisitRow[] }) {
  if (rows.length === 0) return <li className="empty-card">No pending approvals</li>;

  return (
    <>
      {rows.map((visit) => (
        <li key={`pending-${visit.visit_id}`} className="list-item">
          <div>
            <strong>{visit.visitor_name}</strong>
            <p>{visit.purpose || "No purpose"}</p>
          </div>
          <span>{formatDateTime(visit.created_at)}</span>
        </li>
      ))}
    </>
  );
}
